import { MarkAsSentOptions } from 'lib/const/MarkAsSentOptions';
import { ICombinedUserData } from 'lib/context';

export const getMarkAsSentValue = (userData: ICombinedUserData) =>
  !userData.isAutomotive
    ? MarkAsSentOptions.NEVER.value
    : userData.customer.markVideosAsSent === null
    ? MarkAsSentOptions.ASK_VERY_TIME.value
    : parseInt(userData.customer.markVideosAsSent.toString(), 10);
